import * as types from './mutation-types'
import {createFormData} from "@/mixins/Helpers";
/* eslint-disable */

export const createEvent = ({commit}, data) => {
    let formSubmit = createFormData(data)
    return new Promise((resolve, reject) => {
        window.axios.post('store/event', formSubmit).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateEvent = ({commit}, data) => {
    let formSubmit = createFormData(data)
    return new Promise((resolve, reject) => {
        window.axios.post('update/' + data.id + '/event', formSubmit).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadEventStatusEnum = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/event/status/enum').then((response) => {
            commit(types.LOAD_EVENT_STATUS_ENUM, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const downloadParticipatorExcelModel = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('export/participators/template/excel', {responseType: 'blob'}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}



export const getEventDetail = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/detail/' + id + '/event').then((response) => {
            commit(types.SET_CURRENT_EVENT, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const changeEventBanner = ({commit}, {id, data}) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`update/${id}/event/banner`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const sendThanksEmail = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`send/event/${id}/thanks/mail`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const changeEventLogo = ({commit}, {id, data}) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`update/${id}/event/logo`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteEvent = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + id + '/event', id).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadEventStatus = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/event/status/collection').then((response) => {
            commit(types.LOAD_EVENT_STATUS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadEventParticipatorType = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/event/participator/type/enum').then((response) => {
            commit(types.LOAD_EVENT_PARTICIPATOR_TYPE, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadEventInscriptionStatus = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/event/inscription/status/enum').then((response) => {
            commit(types.LOAD_EVENT_INSCRIPTION_STATUS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addParticipator = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`store/event/${data.event_id}/invitation`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateParticipator = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`update/event/${data.id}/invitation`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const changeParticipatorStatus = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/${data.participator_id}/status/atelier`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createEventStatus = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`store/event/status`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadEventPermissions = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/event/permission/collection`, data).then((response) => {
            commit(types.LOAD_EVENT_PERMISSIONS, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadEventTemplateMail = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/eventTemplate/collection`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const loadEventParticipators = ({commit}, eventId) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/event/${eventId}/participators`).then((response) => {
            resolve(response.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadEventValidatedParticipators = ({commit}, eventId) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/validated/event/${eventId}/invitations/collection`).then((response) => {
            commit(types.LOAD_EVENT_VALIDATED_PARTICIPATORS, response.data.participations)

            resolve(response.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadEventInscriptionRequest = ({commit}, {eventId, filter}) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/event/${eventId}/invitation/list`+filter).then((response) => {
            resolve(response.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const validateEventInscriptionRequest = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/inscription/${data.event_inscription_id}/status`, data).then((response) => {
            resolve(response.data)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const getEventInscription = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/invitation/${id}`).then((response) => {
            resolve(response.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getEventDetailForParticipator = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/event/'+ id +'/details').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const sendInvtation = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`send/event/invitation`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const sendWhatsappInvtation = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`events/send/invitation/whatsapp`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const sendImportInvitation = ({commit}, data) => {
    let formSubmit = createFormData(data)
    return new Promise((resolve, reject) => {
        window.axios.post(`send/event/invitation/by/import`, formSubmit).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadParticipators = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/event/'+id+'/participators').then((response) => {
            commit(types.LOAD_EVENT_PARTICIPATORS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadVariables = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/event/email/enum/values').then((response) => {
            commit(types.LOAD_VARIABLES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const importParticipators = ({commit}, data) => {
    let formSubmit = createFormData(data)
    return new Promise((resolve, reject) => {
        window.axios.post(`import/event/${data.event_id}/participators`, formSubmit).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const exportParticipators = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`export/event/${id}/participators`, { responseType: 'blob' }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'participators.xlsx');
            document.body.appendChild(link);
            link.click();
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const saveWebsiteLink = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/event/${data.event_id}/weblink`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadEventInvitationStatus = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/event/invitation/log/enum').then((response) => {
            commit(types.LOAD_EVENT_INVITATION_STATUS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const resendInvitation = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`resend/event/invitation/` + id).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const resendInvitationMail = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`send/invitation/${id}/payment/reminder`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const sendFirstRelanceMail = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`send/first/relance/${id}/mail`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const sendParticipatorFirstRelance = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`send/participator/${id}/first/relance`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const sendParticipatorLastRelance = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`send/participator/${id}/last/relance`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const sendLastRelanceMail = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`send/last/relance/${id}/mail`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const getEventPresenceStats = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/events/${id}/presence/stats`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const saveTemplateSubject = ({commit}, data) => {
    let formSubmit = createFormData(data)
    return new Promise((resolve, reject) => {
        window.axios.post(`builder/template/${data.id}/save/subject`, formSubmit).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const saveTemplateKey = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`store/key/builder`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const askBookForParticipator = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`mark/participators/hasBooks`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}



export const loadTemplateKey = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/key/builder').then((response) => {
            commit(types.LOAD_TEMPLATE_KEY, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const resendParticipator = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`resend/${data.event_id}/event/${data.participator_id}/invitation`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getSenapkonInscription = ({commit}, inscriptionId) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/senapkon/${inscriptionId}/invitation`).then((response) => {
            commit(types.SET_CURRENT_INVITATION, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}






